export enum ConditionInput {
	Slug = "slug",
	ClampPercentage = "clampPercentage",
	IsActive = "isActive",
	MinInstallmentValue = "minInstallmentValue",
}
